// client/src/components/Toast/useToast.ts
import { useToastContextOrThrow } from './ToastProvider';
import type { ShowToastFn } from './types';

export interface UseToastReturn {
  showToast: ShowToastFn;
}

export function useToast(): UseToastReturn {
  const { showToast } = useToastContextOrThrow();
  return { showToast };
}
